export default "__VITE_ASSET__EjQIV2HA__"